export default "__VITE_ASSET__56acc265__"